import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useMemo } from 'react';

import { Accordion } from '@/components/Accordion/Accordion';
import { sumHoldingsGroupCurrentValue } from '@/modules/estate/EstateDirectHoldings/DirectHoldingsGroupContainer/DirectHoldingsGroupContainer.utils';
import { EstatePage_EntityFragment } from '@/modules/estate/graphql/EstatePageData.generated';
import { ContextPrimaryClient } from '@/modules/household/contexts/householdDetails.context';
import { formatCurrencyNoDecimals } from '@/utils/formatting/currency';

import { TrustOrBusiness } from './TrustOrBusiness/TrustOrBusiness';

interface TrustsAndBusinesses {
  holdingsGroups: EstatePage_EntityFragment[];
  clientProfile: ContextPrimaryClient;
}

export function TrustsAndBusinesses({
  holdingsGroups,
  clientProfile,
}: TrustsAndBusinesses) {
  const currentValue = useMemo(
    () => sumHoldingsGroupCurrentValue(holdingsGroups, [clientProfile.id]),
    [holdingsGroups, clientProfile.id]
  );

  if (!holdingsGroups.length) {
    return null;
  }

  return (
    <Accordion
      variant="filled"
      title={
        <Typography variant="title-xs">
          {`${clientProfile.displayName}'s trusts and businesses`}
        </Typography>
      }
      subtitle={`${formatCurrencyNoDecimals(currentValue)}`}
      withDivider={false}
      isDefaultExpanded={false}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 1,
        }}
      >
        {holdingsGroups.map((holdingsGroup) => {
          return (
            <TrustOrBusiness
              holdingsGroup={holdingsGroup}
              key={`trust-and-business-${holdingsGroup.id}`}
              clientProfile={clientProfile}
            />
          );
        })}
      </Box>
    </Accordion>
  );
}
